import { useMutation, useQuery, useQueryClient } from "react-query";
import { CreateTeam, SeasonTeam, UpdateTeam } from "../models/Team";
import { useBackendMutationFunction } from "./common/useBackendMutationFunction";
import { useBackendQueryFunction } from "./common/useBackendQueryFunction";
import { UrlQuery } from "./common/useBackendUrl";

export const GetTeamsKey = "GetTeams";

interface UseGetTeamProps extends UrlQuery {
  id: string;
}

export function useGetTeam(props: UseGetTeamProps) {
  const queryFn = useBackendQueryFunction<SeasonTeam>("/teams/:id", props);

  return useQuery<SeasonTeam>([GetTeamsKey, props], queryFn);
}
interface UseGetTeamsProps extends UrlQuery {
  seasonId: string;
}

export function useGetTeams(props: UseGetTeamsProps) {
  const queryFn = useBackendQueryFunction<SeasonTeam[]>(
    "/seasons/:seasonId/teams",
    props
  );

  return useQuery<SeasonTeam[]>([GetTeamsKey, props], queryFn);
}

interface UseDeleteTeam extends UrlQuery {
  teamId: string;
}
export function useDeleteTeam(props: UseDeleteTeam) {
  const mutationFn = useBackendMutationFunction<SeasonTeam, void>(
    "/teams/:teamId",
    "DELETE",
    props
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetTeamsKey);
    },
  });
}

export function usePostTeam() {
  const mutationFn = useBackendMutationFunction<SeasonTeam, CreateTeam>(
    "/teams",
    "POST"
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetTeamsKey);
    },
  });
}

export function usePatchTeam() {
  const mutationFn = useBackendMutationFunction<SeasonTeam, UpdateTeam>(
    "/teams",
    "PATCH"
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetTeamsKey);
    },
  });
}

interface UseGetTeamOfPlayerProps extends UrlQuery {
  playerId: string;
}
export function useGetTeamOfPlayer(props: UseGetTeamOfPlayerProps) {
  const queryFn = useBackendQueryFunction<SeasonTeam>(
    "/players/:playerId/team",
    props
  );

  return useQuery<SeasonTeam>([GetTeamsKey, props], queryFn);
}
